module.exports = __webpack_public_path__ + "static/media/indus.ebca2be3.jpg";